import React from "react";
import i18n from "../lang/i18n";
import {ValidationFeedback} from "../types/General";
import FeedbackField from "./FeedbackField";
import Icon from "@mdi/react";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({
    fieldKey,
    value,
    placeholder,
    feedback,
    labelTranslationId,
    onChange,
    iconName,
}: {
    fieldKey: string,
    value: string | number | null,
    placeholder: number | null,
    feedback: ValidationFeedback,
    onChange: React.ChangeEventHandler<HTMLInputElement>,
    TaskType: number,
    labelTranslationId: string,
    iconName: string,
}) => {

    const currentValue = value !== null ? String(value) : '';

    return (
        <div className="mb-3">
            <p className="fw-bold mb-2">{i18n.t(labelTranslationId)}</p>
            <div className="input-group">
                <span className="input-group-text text-primary">
                    <Icon path={iconName} size={.8}/>
                </span>
                <input
                    name={fieldKey}
                    value={currentValue}
                    placeholder={placeholder !== null ? String(placeholder) : ''}
                    onChange={onChange}
                    className="form-control"
                    type={fieldKey === 'Notes' ? 'text' : 'number'}
                    pattern={fieldKey === 'Notes' ? undefined : '[0-9].[0-9]'}
                />
            </div>
            <FeedbackField feedback={feedback}/>
        </div>
    );
}